import React from 'react';
import { motion } from 'framer-motion';
import './EntrenamientoGrupo.css';

export default function EntrenamientoGrupo() {
  const caracteristicas = [
    "Horarios predeterminados (reservas vía app)",
    "Grupos de hasta 8 personas",
    "Opción de acudir 2 días/semana o acceso ilimitado"
  ];

  const precios = [
    { descripcion: "2 días/semana", precio: "75 €" },
    { descripcion: "Ilimitado", precio: "100 € (incluye 10% de descuento en fisioterapia y rehabilitación)" }
  ];

  return (
    <div className="grupo-container">
      <motion.h1 
        className="grupo-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        ENTRENAMIENTO EN GRUPO
      </motion.h1>

      <motion.p 
        className="grupo-description"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.4, duration: 0.8 }}
      >
        Dirigido a personas que busquen mantener una vida activa, mejorar su salud y disfrutar del buen ambiente que caracteriza los grupos.
      </motion.p>

      <motion.div 
        className="grupo-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.8 }}
      >
        <h2>Características</h2>
        <ul className="grupo-list">
          {caracteristicas.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </motion.div>

      <motion.div 
        className="grupo-section"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.8, duration: 0.8 }}
      >
        <h2>Precios</h2>
        <div className="grupo-precios">
          {precios.map((item, index) => (
            <div key={index} className="grupo-precio-cell">
              <p className="grupo-precio">{item.precio}</p>
              <p className="grupo-descripcion">{item.descripcion}</p>
            </div>
          ))}
        </div>
        <p className="grupo-note">Precios mensuales por persona.</p>
      </motion.div>
    </div>
  );
}
